SlideView  = require("views/slide")
TimerModel = require("models/game/timer")
ScoreModel = require("models/game/score")

class GameView extends SlideView

  initialize: ->
    super

    @el.classList.add("game-slide")

    @createModels()

  serialize: ->
    data = super      
    _.extend(data, {
      hasTimeLimit: @hasTimeLimit()
    })

  createModels: ->
    @game    ?= {}
    models    = { timer: TimerModel, score: ScoreModel, extra: Backbone.Model }

    for key, Model of models
      @game[key]?.off().destroy?()
      options = @options.data.game?[key] or {}
      @game[key] = new Model(options)

  # Set the `state-intro` class when the game slide is shown.
  show: ->
    @setState("intro", "game")

    @listenTo @game.timer, "change", @onTimerChange
    @listenTo @game.score, "change", @onScoreChange
    Application.publish("event:slide-rendered") {}

  # Track the highest score when we leave the slide
  hide: ->
    @stopListening()
    @game.timer?.destroy()

    @setState(false, "game")

    @trackEvent
      category: "Game"
      action: "Record"
      label: @game.score.get("record")

  onRefresh: ->
    @game.timer?.clearTimers()

    @el.classList.remove("game-count-down", "game-paused", "game-playing")

    @createModels()
    @show()
    @preloadMedia()

  # Enter the game, triggering a count down and resetting both models. Used to
  # reveal the game before the user can actually start playing. Game slides
  # become locked when playing and are unlocked after the scores have been
  # displayed.
  enterGame: ->
    @lock() unless @options.data
    @setState("playing", "game")

    @game.score.trigger "reset"
    @game.timer.trigger "reset"

    if @hasTimeLimit()
      @game.timer.trigger "count", callback: => @startGame()
    else
      # If there is no countdown, we need to start game in a timeout because some
      # games rely on the countdown to have DOM elements ready
      window.setTimeout =>
        @startGame()
      , 0

  # The game is now playable and the timer is active...
  startGame: ->
    if @hasTimeLimit()
      callback = => @endGame()
    else
      callback = => @game.timer.trigger "stop"

    @game.timer?.trigger "start", { callback }

  # The game's time limit has elapsed, so trigger a tallying up of the total score
  endGame: ->
    @setState("outro", "game")

    # Prevent race condition on stopping tally sound before starting to play it
    # on slower devices when there is no score animation (zero score)
    window.setTimeout =>
      @game.score.trigger "tally", callback: => @afterAnimateScores()
    , 0
    @game.timer.trigger "stop"

  # Easy access to pause/unpause methods that can be passed directly into the
  # view's event object.
  pauseGame: ->
    @game.timer.set paused: true

  unpauseGame: ->
    @game.timer.set paused: false

  togglePaused: ->
    @game.timer.set paused: not @game.timer.get("paused")

  # The scores have now been tallied up and reflect accurate values...
  afterAnimateScores: ->
    @unlock() unless @options.data

    @trackEvent
      category: "Game"
      action: "Score"
      label: @game.score.get("total")

    @slideCompleted()

  # Answers can play a sound, increase the score, and adjust
  # the amount of time remaining.
  onCorrectAnswer: ({sound, score, time, tally} = {}) ->
    return if @hasTimeLimit() and @game.timer.get("paused")

    time  ?= 0
    score ?= 0
    total = @game.score.get("total")

    @game.timer.setBy bonus: time
    @game.score.setBy
      consecutive: 1
      correct: 1

    @game.score.setBy
      score: score
    , silent: tally?

    if tally
      @game.score.trigger "tally", {tallyFrom: total, ms: 300}

  onIncorrectAnswer: ({sound, score, time, tally} = {}) ->
    return if @hasTimeLimit() and @game.timer.get("paused")

    time  ?= 0
    score ?= 0
    total = @game.score.get("total")

    @game.timer.setBy bonus: -time
    @game.score.set consecutive: 0

    @game.score.setBy
      score: -score
      incorrect: 1
    , silent: tally?

    if tally
      @game.score.trigger "tally", {tallyFrom: total, ms: 300}

  # Timer and score handlers are passed their respective models. These methods
  # will be overidden by game instances
  onTimerChange: (timer) ->

  onScoreChange: (score) ->

  # Store an array for quick access to random keys via `@getRandom(key)`.
  setArray: (array, key) ->
    [array, key] = [key, array] if _.isString(array)

    @data ?= {}
    @data[key] =
      current: _.shuffle(array)
      original: _.clone(array)

  getArray: (key) ->
    @data[key].original

  # Cycle through a shuffled array and replace it's contents when done,
  # ensuring the last value won't be reselected after shuffling by placing it
  # at the end of the array.
  getRandom: (key) ->
    if @data[key].current.length is 0
      @data[key].current =
        _
          .chain(@data[key].original)
          .without(@data[key].lastValue)
          .shuffle()
          .value()
          .concat(@data[key].lastValue)

    @data[key].lastValue = @data[key].current.shift()

  getNext: (key) ->
    if @data[key].current.length is 0
      @data[key].current = @data[key].original

    @data[key].lastValue = @data[key].current.shift()

  hasTimeLimit: ->
    not @options.data.game?.timer?.isDisabled and @options.data.game?.timer?.limit > 0

module.exports = GameView
